export enum RecommendedStatus {
    Active = 'Active',
    Completed = 'Completed',
    Archived = 'Archived',
    Ignored = 'Ignored',
    CompletedAlternate = 'CompletedAlternate'
}
